import { useState, useCallback } from "react";
import { UseReverseGeocodingReturn } from "type";

export const useReverseGeocoding = (): UseReverseGeocodingReturn => {
  const [locationName, setLocationName] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getLocationName = useCallback(
    async (position: google.maps.LatLngLiteral) => {
      setLoading(true);
      setError(null);
      try {
        const geocoder = new google.maps.Geocoder();
        const result = await geocoder.geocode({ location: position });
        if (result.results && result.results.length > 0) {
          setLocationName(result.results[0].formatted_address);
        } else {
          setLocationName(
            `${position.lat.toFixed(4)}, ${position.lng.toFixed(4)}`
          );
        }
      } catch (err) {
        console.error("Geocoding error:", err);
        setError("Failed to load location");
        setLocationName(
          `${position.lat.toFixed(4)}, ${position.lng.toFixed(4)}`
        );
      } finally {
        setLoading(false);
      }
    },
    []
  );
  const reset = useCallback(() => {
    setLocationName(null);
    setLoading(false);
    setError(null);
  }, []);

  return {
    getLocationName,
    locationName,
    loading,
    error,
    reset,
  };
};
